export const getAppConfig = () => {
  return (
    window.__APP_CONFIG__ || {
      defaultImage: "/img/null.jpg",
    }
  );
};
